export default "__VITE_ASSET__BeS0cCSh__"